import { Component, Input, OnChanges } from "@angular/core";
import { HC_COLORS } from "../highcharts-shared";

@Component({
  selector: "app-sparkline",
  standalone: true,
  imports: [],
  styles: [
    `
      :host {
        display: inline-block;
        line-height: 0;
      }
      svg {
        display: block;
        overflow: visible;
      }
    `,
  ],
  template: `
    <svg
      class="sparkline"
      [attr.viewBox]="'0 0 ' + width + ' ' + height"
      [attr.width]="width"
      [attr.height]="height"
      preserveAspectRatio="none"
    >
      @if (points.length > 1) {
        <ng-container>
          <path [attr.d]="areaPath" [style.fill]="color" fill-opacity="0.22" />
          <path
            [attr.d]="linePath"
            fill="none"
            [style.stroke]="color"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <circle
            [attr.cx]="lastX"
            [attr.cy]="lastY"
            r="2.2"
            [style.fill]="color"
          />
        </ng-container>
      }
    </svg>
  `,
})
export class SparklineComponent implements OnChanges {
  @Input() width = 140;
  @Input() height = 36;
  @Input() color = HC_COLORS.accent;
  @Input() set data(values: number[] | null | undefined) {
    this.points = Array.isArray(values)
      ? values.filter((v) => typeof v === "number" && isFinite(v))
      : [];
    this.recompute();
  }

  points: number[] = [];
  linePath = "";
  areaPath = "";
  lastX = 0;
  lastY = 0;

  ngOnChanges(): void {
    this.recompute();
  }

  private recompute(): void {
    const pts = this.points;
    if (pts.length < 2) {
      this.linePath = "";
      this.areaPath = "";
      return;
    }
    const min = Math.min(...pts);
    const max = Math.max(...pts);
    const range = max - min || 1;
    const stepX = this.width / (pts.length - 1);
    const pad = 3;
    const h = this.height - pad * 2;
    const mapped = pts.map((v, i) => {
      const x = i * stepX;
      const y = pad + h - ((v - min) / range) * h;
      return { x, y };
    });
    this.linePath = mapped
      .map(
        (p, i) => `${i === 0 ? "M" : "L"}${p.x.toFixed(2)},${p.y.toFixed(2)}`,
      )
      .join(" ");
    this.areaPath =
      `M${mapped[0].x},${this.height} ` +
      mapped.map((p) => `L${p.x.toFixed(2)},${p.y.toFixed(2)}`).join(" ") +
      ` L${mapped[mapped.length - 1].x},${this.height} Z`;
    const last = mapped[mapped.length - 1];
    this.lastX = last.x;
    this.lastY = last.y;
  }
}
